import { Injectable } from '@angular/core';
import { DeliveryNote, Company } from './api.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DnPrint2Service {
    private fmtDate(d?: string): string {
        if (!d) return '';
        const dt = new Date(d);
        return isNaN(dt.getTime()) ? '' : dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    }
    private v(x: any): string {
        return x === null || x === undefined || x === '' ? '' : String(x);
    }
    private img(path?: string): string {
        return path ? environment.serverUrl + path : '';
    }

    private slipHtml(r: DeliveryNote, c: Company): string {
        const logo = this.img(c.logoPath);

        // chamber rows (1-5) - har chamber ka data
        const q = [r.quantityCh1, r.quantityCh2, r.quantityCh3, r.quantityCh4, r.quantityCh5];
        const p = [r.productCh1, r.productCh2, r.productCh3, r.productCh4, r.productCh5];
        const lrd = [r.loadRefDipCh1, r.loadRefDipCh2, r.loadRefDipCh3, r.loadRefDipCh4, r.loadRefDipCh5];
        const lpd = [r.loadProdDipCh1, r.loadProdDipCh2, r.loadProdDipCh3, r.loadProdDipCh4, r.loadProdDipCh5];
        const lt = [r.loadTempCh1, r.loadTempCh2, r.loadTempCh3, r.loadTempCh4, r.loadTempCh5];
        const ld = [r.loadDensityCh1, r.loadDensityCh2, r.loadDensityCh3, r.loadDensityCh4, r.loadDensityCh5];
        const rrd = [r.recvRefDipCh1, r.recvRefDipCh2, r.recvRefDipCh3, r.recvRefDipCh4, r.recvRefDipCh5];
        const rpd = [r.recvProdDipCh1, r.recvProdDipCh2, r.recvProdDipCh3, r.recvProdDipCh4, r.recvProdDipCh5];
        const rt = [r.recvTempCh1, r.recvTempCh2, r.recvTempCh3, r.recvTempCh4, r.recvTempCh5];
        const rd = [r.recvDensityCh1, r.recvDensityCh2, r.recvDensityCh3, r.recvDensityCh4, r.recvDensityCh5];
        const smm = [r.shortInMMCh1, r.shortInMMCh2, r.shortInMMCh3, r.shortInMMCh4, r.shortInMMCh5];
        const slt = [r.shortInLtrsCh1, r.shortInLtrsCh2, r.shortInLtrsCh3, r.shortInLtrsCh4, r.shortInLtrsCh5];

        let chamberRows = '';
        for (let i = 0; i < 5; i++) {
            chamberRows += `
                <tr>
                    <td class="c">${i + 1}</td>
                    <td class="c">${this.v(q[i])}</td>
                    <td class="c">${this.v(p[i])}</td>
                    <td class="c">${this.v(lrd[i])}</td>
                    <td class="c">${this.v(lpd[i])}</td>
                    <td class="c">${this.v(lt[i])}</td>
                    <td class="c">${this.v(ld[i])}</td>
                    <td class="c">${this.v(rrd[i])}</td>
                    <td class="c">${this.v(rpd[i])}</td>
                    <td class="c">${this.v(rt[i])}</td>
                    <td class="c">${this.v(rd[i])}</td>
                    <td class="c">${this.v(smm[i])}</td>
                    <td class="c">${this.v(slt[i])}</td>
                </tr>`;
        }

        return `
        <div class="dn">
            ${
                c.showDnHeader === false
                    ? `<div class="head head-min"><div class="head-title"><div class="subtitle">Delivery Advice Note</div></div></div>`
                    : `<div class="head">
                        ${logo ? `<img class="logo" src="${logo}" />` : '<div class="logo-space"></div>'}
                        <div class="head-title">
                            <div class="company">${this.v(c.name)}</div>
                            <div class="subtitle">Delivery Advice Note</div>
                        </div>
                        <div class="logo-space"></div>
                   </div>`
            }

            <table class="info">
                <tr>
                    <td class="lbl">From (Location)</td><td class="cl">:</td><td class="val">${this.v(r.fromLocation)}</td>
                    <td class="lbl">To (Location)</td><td class="cl">:</td><td class="val">${this.v(r.toLocation)}</td>
                </tr>
                <tr>
                    <td class="lbl">Date</td><td class="cl">:</td><td class="val">${this.fmtDate(r.documentDate)}</td>
                    <td class="lbl">DN Number</td><td class="cl">:</td><td class="val">${this.v(r.dnNumber)}</td>
                </tr>
                <tr>
                    <td class="lbl">Tank Lorry No.</td><td class="cl">:</td><td class="val">${this.v(r.tankLorryNo)}</td>
                    <td class="lbl">Indent Number</td><td class="cl">:</td><td class="val">${this.v(r.indentNumber)}</td>
                </tr>
                <tr>
                    <td class="lbl">Quantity</td><td class="cl">:</td><td class="val">${this.v(r.quantity)}</td>
                    <td class="lbl">Calibration No.</td><td class="cl">:</td><td class="val">${this.v(r.calibrationNo)}</td>
                </tr>
                <tr>
                    <td class="lbl">Carriage Cont.</td><td class="cl">:</td><td class="val">${this.v(r.carriageContractor)}</td>
                    <td class="lbl">Calibration Expiry</td><td class="cl">:</td><td class="val">${this.v(r.calibrationExpiry)}</td>
                </tr>
                <tr>
                    <td class="lbl">Delivery Address</td><td class="cl">:</td><td class="val" colspan="4">${this.v(r.deliveryAddress)}</td>
                </tr>
            </table>

            <div class="op-title">Operational Data</div>
            <table class="op">
                <thead>
                    <tr>
                        <th rowspan="2">Chamber No.</th>
                        <th rowspan="2">Quantity</th>
                        <th rowspan="2">Product</th>
                        <th colspan="4">Loading Location</th>
                        <th colspan="4">Receiving Location</th>
                        <th colspan="2">Shortage</th>
                    </tr>
                    <tr>
                        <th>Ref. Dip</th><th>Product Dip</th><th>Temp. (&deg;F)</th><th>Density</th>
                        <th>Ref. Dip</th><th>Product Dip</th><th>Temp.</th><th>Density</th>
                        <th>In MM</th><th>In Ltrs</th>
                    </tr>
                </thead>
                <tbody>
                    ${chamberRows}
                    <tr class="totalrow">
                        <td class="c noborder"><b>Total</b><br>Ambient Litters</td>
                        <td class="c underline-only">${this.v(r.totalAmbientLitters)}</td>
                        <td colspan="4" class="noborder"></td>
                        <td colspan="2" class="c noborder"><b>Metric Tons</b></td>
                        <td colspan="3" class="c underline-only">${this.v(r.metricTons)}</td>
                    </tr>
                </tbody>
            </table>

            <table class="seal">
                <tr>
                    <td class="lbl seal-lbl" rowspan="2">Seal Numbers</td>
                    <td class="seal-val c" rowspan="2">${this.v(r.sealNumber)}</td>
                    <td class="hdr">Total</td>
                </tr>
                <tr>
                    <td class="c">${this.v(r.sealTotal)}</td>
                </tr>
            </table>

            <table class="cumul">
                <tr>
                    <td class="lbl" rowspan="2">Commulative Shortage</td>
                    <td class="hdr">Amb. Litters</td><td class="hdr">Standard Litters</td><td class="hdr">Metric Tons</td>
                </tr>
                <tr>
                    <td class="c">${this.v(r.cumulShortAmbLtrs)}</td>
                    <td class="c">${this.v(r.cumulShortStdLtrs)}</td>
                    <td class="c">${this.v(r.cumulShortMTons)}</td>
                </tr>
            </table>

            <table class="netrecv">
                <tr>
                    <td class="lbl" rowspan="2">Net Received</td>
                    <td class="hdr">Amb. Litters</td><td class="hdr">Standard Litters</td><td class="hdr">Metric Tons</td>
                </tr>
                <tr>
                    <td class="c">${this.v(r.netRecvAmbLtrs)}</td>
                    <td class="c">${this.v(r.netRecvStdLtrs)}</td>
                    <td class="c">${this.v(r.netRecvMTons)}</td>
                </tr>
            </table>

            <div class="sign">
                <div class="sign-line"></div>
                <div class="sign-label">Authorized Signature</div>
            </div>
        </div>`;
    }

    private styles(): string {
        return `
        <style>
            * { font-family: Arial, Helvetica, sans-serif; box-sizing: border-box; }
            body { margin: 0; color: #000; }
            .dn { width: 100%; padding: 5mm; page-break-after: always; }
            .dn:last-child { page-break-after: auto; }

            .head { display: flex; align-items: center; margin-bottom: 10px; }
            .logo { max-height: 60px; max-width: 90px; object-fit: contain; }
            .logo-space { width: 90px; }
            .head-title { flex: 1; text-align: center; }
            .company { font-size: 22px; font-weight: bold; }
            .subtitle { font-size: 14px; font-weight: bold; margin-top: 2px; }

            table { border-collapse: collapse; width: 100%; }
            .info td { border: 1px solid #000; padding: 3px 6px; font-size: 11px; }
            .info .lbl { font-weight: bold; width: 13%; white-space: nowrap; }
            .info .cl { width: 1%; text-align: center; }
            .info .val { width: 20%; }

            .op-title { font-size: 13px; margin: 10px 0 3px; }
            .op th, .op td { border: 1px solid #000; font-size: 9px; padding: 3px 2px; text-align: center; vertical-align: middle; }
            .op th { background: #f0f0f0; font-weight: bold; }
            .op td { height: 20px; }

            /* total row: box nahi, sirf value ke neeche line */
            .op td.noborder { border: none; }
            .op td.underline-only { border: none; border-bottom: 3px double #000; font-weight: normal; }

            .seal, .cumul, .netrecv { margin-top: 10px; }
            .seal td, .cumul td, .netrecv td { border: 1px solid #000; font-size: 10px; padding: 4px 6px; height: 22px; }
            .seal .seal-lbl, .cumul .lbl, .netrecv .lbl { font-weight: bold; text-align: center; width: 22%; }
            .seal .hdr, .cumul .hdr, .netrecv .hdr { text-align: center; font-weight: bold; width: 13%; }
            .seal .seal-val { width: 65%; }
            .c { text-align: center; }

            .sign { margin-top: 45px; }
            .sign-line { width: 220px; border-top: 1px solid #000; margin-bottom: 4px; }
            .sign-label { font-size: 11px; font-weight: bold; }

            @media print {
                @page { size: A4 portrait; margin: 10mm; }
                .dn { padding: 0; }
            }
        </style>`;
    }

    print(records: DeliveryNote[], companies: Company[]): void {
        const map = new Map<number, Company>();
        companies.forEach((c) => map.set(c.id, c));

        const slips = records
            .map((r) => {
                const c = map.get(r.companyId) || ({} as Company);
                return this.slipHtml(r, c);
            })
            .join('');

        const html = `<html><head><title>Delivery Advice Note</title>${this.styles()}</head>
            <body>${slips}<script>window.onload=function(){ setTimeout(function(){ window.print(); }, 400); }</script></body></html>`;

        const win = window.open('', '_blank', 'width=900,height=1000');
        if (win) {
            win.document.open();
            win.document.write(html);
            win.document.close();
        }
    }
}
